import { getReducerName } from 'data/dataSourceConstants';
import { useDispatch } from 'react-redux';
import dataTables from 'view/dataTables';
import { dataConfig } from 'data/dataConfig';
import { selectDataSet, selectCategory } from 'reducers/overviewDataSetReducer';

function WorkAppLink(props) {
	const dispatch = useDispatch();

	try {
		const { rowData, propertyData } = props;

		if (!rowData || !rowData.job_number) {
			return '-';
		}

		if (!propertyData || !propertyData.address) {
			return '-';
		}

		const source = rowData.source;

		let dataSet, dataSource;

		if (source === 'BIS') {
			dataSet = 'jobApplications';
			dataSource = 'BIS';
		} else if (source === 'DOBNow') {
			dataSet = 'dobJobApplications';
			dataSource = 'OPEN_DATA';
		} else {
			return '-'; // Return '-' if source is unknown
		}

		const handleClick = () => {
			// Select infrastructure category
			dispatch(selectCategory('infrastructure'));
			
			// Select the appropriate dataset (without filtering)
			const options = {
				dataSet: dataSet,
				reducerName: getReducerName(dataConfig[dataSet], dataSource),
				dataSource: dataSource,
				title: dataTables[dataSet].title,
				columns: dataTables[dataSet][dataSource].columns,
				tableView: dataSet === 'jobApplications' ? 'grouped' : null,
			};
			dispatch(selectDataSet(options));
		};

		return (
			<button className="btn btn-hyperlink" onClick={handleClick}>
				<i className="bi bi-box-arrow-up-right" />
			</button>
		);
	} catch (error) {
		console.error('Error in WorkAppLink:', error);
		return 'ERROR';
	}
}

export default WorkAppLink;